import { defineMessages } from '@/i18n';

export const appMessages = defineMessages({
  refreshButtonLabel: 'platform.app.refresh.buttonLabel',
  refreshBannerTitle: 'platform.app.refresh.bannerTitle',
});
